"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flagIconModulePath = exports.flagIconClassesPrefix = exports.flagIconClassesPrefixName = exports.baseThemeStyleName = void 0;
var baseThemeStyleName = 'theme-base';
exports.baseThemeStyleName = baseThemeStyleName;
var flagIconClassesPrefixName = 'flag-icon';
exports.flagIconClassesPrefixName = flagIconClassesPrefixName;
var flagIconClassesPrefix = "".concat(flagIconClassesPrefixName, "-");
exports.flagIconClassesPrefix = flagIconClassesPrefix;
var flagIconModulePath = 'node_modules/flag-icon-css';
exports.flagIconModulePath = flagIconModulePath;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/constants.js
// module id = 141
// module chunks = 168707334958949